module.exports = new __parcel__URL__("grapes.6a50728f.svg").toString();